import { Mutable, NotificationIdentifier } from '@evorait/pace-core';
import { Action, createReducer, on } from '@ngrx/store';
import { FormIdentifier } from '../../types/form-identifier';
import { NotificationUtilities } from '../../utilities/notification-utilities';
import { deleteLastOpenedForm, restoreLastOpenedForm, updateLastOpenedForm } from '../actions/last-opened-form.actions';
import { initialLastOpenedFormState, LastOpenedFormState } from '../state/last-opened-form.state';
import { handOverUnsubmittedFormsSuccess } from '../actions/state.actions';

function updateLastOpenedFormReducer(
    state: Readonly<LastOpenedFormState>,
    props: { notification: NotificationIdentifier; form: FormIdentifier },
): Readonly<LastOpenedFormState> {
    const key = NotificationUtilities.toString(props.notification);
    return { ...state, [key]: props.form };
}

function deleteLastOpenedFormReducer(
    state: Readonly<LastOpenedFormState>,
    props: { notification: NotificationIdentifier },
): Readonly<LastOpenedFormState> {
    const key = NotificationUtilities.toString(props.notification);
    const newLastOpenedForm: Mutable<LastOpenedFormState> = { ...state };
    delete newLastOpenedForm[key];
    return newLastOpenedForm;
}

function restoreLastOpenedFormReducer(
    state: Readonly<LastOpenedFormState>,
    props: { lastOpenedForm: LastOpenedFormState },
): Readonly<LastOpenedFormState> {
    return { ...props.lastOpenedForm };
}

const createLastOpenedFormReducer = createReducer(
    initialLastOpenedFormState,
    on(updateLastOpenedForm, updateLastOpenedFormReducer),
    on(deleteLastOpenedForm, deleteLastOpenedFormReducer),
    on(restoreLastOpenedForm, restoreLastOpenedFormReducer),
    on(handOverUnsubmittedFormsSuccess, () => initialLastOpenedFormState),
);

export function lastOpenedFormReducer(
    state: Readonly<LastOpenedFormState>,
    action: Action,
): Readonly<LastOpenedFormState> {
    return createLastOpenedFormReducer(state, action);
}
